// the number of subpages that exist in each section of the retirement blueprint
export default {
  retirementBlueprint: 2,
  personalDetails: 7,
  targetWealth: 1,
  targetSaving: 1,
  summary: 1,
};
